import { fetchListingAssets } from '../fetchListingAssets';
import { fetchVariantAssets } from '../fetchVariantAssets';

import {
  getListingProductIdFromState,
  listListingVariantsForChannel,
} from './entityReadHelpers';

const DEFAULT_ES_INDEXING_DELAY_MS = 2000;

const sleep = (ms) => new Promise((resolve) => {
  setTimeout(resolve, ms);
});

const resolveListings = ({
  listings, getState, productId, channelIds = [],
}) => {
  if (listings?.length) {
    return listings.filter(({ channelId, listingProductId }) => channelId && listingProductId);
  }

  const productsState = getState().products;

  return channelIds
    .map((channelId) => {
      const listingProductId = getListingProductIdFromState(productsState, productId, channelId);
      if (!listingProductId) return null;
      return { channelId, listingProductId };
    })
    .filter(Boolean);
};

const refreshListingAssetsForChannels = async ({
  dispatch,
  getState,
  productId,
  channelIds,
  listings,
  delayMs = DEFAULT_ES_INDEXING_DELAY_MS,
}) => {
  const resolvedListings = resolveListings({
    listings,
    getState,
    productId,
    channelIds,
  });

  if (!resolvedListings.length) return;

  if (delayMs > 0) {
    await sleep(delayMs);
  }

  const productsState = getState().products;

  await Promise.all(resolvedListings.map(async ({ channelId, listingProductId }) => {
    await dispatch(fetchListingAssets({
      masterProductId: productId,
      channelId,
      listingProductId,
    }));

    const listingVariants = listListingVariantsForChannel(
      productsState,
      productId,
      channelId,
    );

    await Promise.all(listingVariants.map(async (listingVariant) => {
      if (!listingVariant?._id || !listingVariant?.masterVariantId) return;

      await dispatch(fetchVariantAssets({
        productId,
        variantId: listingVariant._id,
        channelId,
        masterVariantId: listingVariant.masterVariantId,
      }));
    }));
  }));
};

export default refreshListingAssetsForChannels;
